import { createMediaWrapperView } from 'components/upload/plugins/video-preview/createMediaWrapperView';
import 'components/upload/plugins/video-preview/index.css';
import { isPreviewableVideo } from 'components/upload/plugins/video-preview/util';

const DEFAULT_HEIGHT = 150;

const MediaPreviewPlugin = (fpAPI: any) => {
    const { addFilter, utils } = fpAPI;
    const { Type, createRoute } = utils;
    const mediaWrapperView = createMediaWrapperView(fpAPI);

    // called for each view that is created right after the 'create' method
    addFilter('CREATE_VIEW', (viewAPI: any) => {
        // get reference to created view
        const { is, view, query } = viewAPI;

        // only hook up to item view
        if (!is('file')) {
            return;
        }

        // create the media preview plugin, but only do so if the item is video or audio
        const didLoadItem = ({ root, props }: any) => {
            const { id } = props;
            const item = query('GET_ITEM', id);
            const allowVideoPreview = query('GET_ALLOW_VIDEO_PREVIEW');

            if (!item || item.archived || !isPreviewableVideo(item.file) || !allowVideoPreview) {
                return;
            }

            // set preview view
            root.ref.mediaPreview = view.appendChildView(
                view.createChildView(mediaWrapperView, { id }),
            );

            // now ready
            root.dispatch('DID_MEDIA_PREVIEW_CONTAINER_CREATE', { id });
        };

        // start writing
        view.registerWriter(
            createRoute(
                {
                    DID_LOAD_ITEM: didLoadItem,
                },
                ({ root, props }: any) => {
                    const { id } = props;
                    const item = query('GET_ITEM', id);
                    const allowVideoPreview = root.query('GET_ALLOW_VIDEO_PREVIEW');

                    // don't do anything while not a video or audio file or hidden
                    if (
                        !item ||
                        !isPreviewableVideo(item.file) ||
                        !allowVideoPreview ||
                        root.rect.element.hidden
                    )
                        return;
                },
            ),
        );
    });

    return {
        options: {
            allowVideoPreview: [true, Type.BOOLEAN],
            videoPreviewHeight: [DEFAULT_HEIGHT, Type.INT],
        },
    };
};

export { MediaPreviewPlugin };
